import React from "react";
import PublHomeData from "./PublHomeData";
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FaIndianRupeeSign } from "react-icons/fa6";
import { IoIosCart } from "react-icons/io";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "./PubUsrPro.css";

export default function PubUsrPro() {
  const phoneNo = useSelector((state) => state.pubLogin.userPhone);
  const navigate = useNavigate();

  const handleAddToCart = async (e, product) => {
    e.stopPropagation();
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/checkCart`,
        { productName: product.name, customerPhone: phoneNo }
      );

      if (response.data.exists) {
        toast.info(`${product.name} is already in the cart. You can increase the quantity.`, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        // Product is not in the cart, proceed to add
        const newData = {
          productName: product.name,
          productWeight: product.weight,
          productPrice: product.price,
          customerPhone: phoneNo,
        };

        toast.success(`${product.name} added to cart!`, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });

        await axios.post(`${process.env.REACT_APP_API_URL}/pubCart`, newData);
      }
    } catch (error) {
      console.error("Error checking cart:", error.message);
      if (error.response) {
        console.error("Server responded with status:", error.response.status);
      }
    }
  };

  const handleClick = (product) => {
    navigate("/productPage", { state: { product } });
  };

  const noSelectStyle = {
    userSelect: "none",
    WebkitUserSelect: "none",
    MozUserSelect: "none",
    msUserSelect: "none",
    OUserSelect: "none",
  };

  // Filter products where onOffer is true and outOfStock is false
  const filteredProducts = PublHomeData.filter((product) => product.onOffer && !product.outOfStock);

  return (
    <div className="container">
      <div className="text-center mb-5">
        <h1>Today's Special Offers</h1>
      </div>
      <div className="row d-flex justify-content-center" style={noSelectStyle}>
        {filteredProducts.map((product, index) => (
          <div
            className="col-lg-4 col-md-4 mb-4 d-flex justify-content-center"
            key={index}
            data-aos="fade-up"
            data-aos-delay={index * 100}

          >
            <div
              className="card h-100"
              onClick={() => handleClick(product)}
              style={{ width: "18rem", cursor: "pointer" }}
            >
              <img
                src={product.img}
                className="card-img-top"
                alt={product.name}
                style={{ height: "200px", objectFit: "cover" }}
              />
              <div className="card-body d-flex flex-column" style={noSelectStyle}>

                {/* Product Name: premium font and style */}
                <h4
                  className="card-title"
                  style={{
                    ...noSelectStyle,
                    fontFamily: "'Playfair Display', serif", // premium font
                    color: "#13547a",
                    fontWeight: "bold",
                    fontSize: "1.7rem",
                    letterSpacing: "1px",
                    textShadow: "1px 2px 8px #d8eaf3"
                  }}
                >
                  {product.name}
                </h4>

                {/* Price: stylish and green */}
                <h4
                  className="card-text"
                  style={{
                    ...noSelectStyle,
                    color: "#21b573",
                    fontSize: "1.2rem",
                    marginTop: "0.5rem",
                    fontWeight: "600",
                    display: "flex",
                    alignItems: "center",
                    gap: "4px"
                  }}
                >
                  Price: <FaIndianRupeeSign style={{ color: "#21b573", fontSize: "1.1rem" }} /> {product.price}
                </h4>
                          <h6 className="card-text">Including GST, shipping & packaging</h6>
                                    <h5 style={{   
                                         fontSize: "1.08rem",
                                       color: "#444",
                                      fontWeight: "600",
                                      letterSpacing: "0.3px",
                                        marginTop: "0.4rem"
       
                                      }} >Quantity: {product.weight}</h5>
                <div className="mt-auto d-flex justify-content-center">
                  <button
                    type="button"
                    className="btn btn-outline-dark mt-2 mb-2 text-center btn-md rounded-pill shadow"
                    onClick={(e) => handleAddToCart(e, product)}
                  >
                    <IoIosCart /> Add to Cart
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      <ToastContainer />
    </div>
  );
}
